<form class="lv-artefact-container lv-component"
     [ngClass]="!!uiArtefakt?.Ausrichtung ? uiArtefakt?.Ausrichtung : uiAusrichtung">
  <div [@inOut] *ngIf="show && !!adressKorrektur && !!adressKorrektur.Status && adressKorrektur.Status !== uiAdressStatus.ADRESSE_KORREKT" class="lv-artefact" [ngClass]="uiArtefakt.BreiteInPixel">
    <input #lvHiddenAdressInput="ngModel" [name]="'lvHiddenAdress'" [(ngModel)]="hiddenInputmodel" class="lv-hidden-form" required>
    <div *ngIf="adressKorrektur.Status === uiAdressStatus.ADRESSE_KORRIGIERT" [ngClass]="{'lv-adress-vorschlag': true, 'lv-error-state': !!getError()}">
      <lv-label-tooltip
                        [label]="uiArtefakt.Text"
                        [labelSymbol]="nestedSymbol"
                        [tooltip]="uiArtefakt.InfoTextTooltipCollapsable"
                        [isPflichtfeld]="uiArtefakt.PflichtfeldJN"
                        [isCollapsable]="uiArtefakt.InfoTextTooltipCollapsableTyp === 'Collapsable'"
                        (infotextCollapsableChange)="infotextCollapsableChange($event)">
      </lv-label-tooltip>

      <div class="lv-adress-korrektur">
        <div class="lv-adress-korrektur-zeile">
          <div [innerHTML]="adressKorrektur[alleAdressBestandteile[0]]" class="lv-adress-korrektur-zeile-erster"></div>
          <div [innerHTML]="adressKorrektur[alleAdressBestandteile[1]]"></div>
        </div>
        <div class="lv-adress-korrektur-zeile">
          <div [innerHTML]="adressKorrektur[alleAdressBestandteile[2]]" class="lv-adress-korrektur-zeile-erster"></div>
          <div [innerHTML]="adressKorrektur[alleAdressBestandteile[3]]"></div>
        </div>
      </div>

      <div class="lv-adress-korrektur-button-container">
        <button [textContent]='"Adressvorschlag übernehmen"' mat-raised-button class="lv-adress-korrektur-button" (click)="onClick(true)"></button>
        <div class="lv-adress-korrektur-eigene-eingabe">Sie können auch Ihre Eingabe verwenden:</div>
        <button [textContent]='"Eigene Eingabe verwenden"' mat-raised-button class="lv-adress-korrektur-button" (click)="onClick(false)"></button>
      </div>

      <div>
        <mat-error class="lv-error-meldung-style" *ngIf="getError() as error"
                   [ngClass]="{'lv-show-untruncated-error': showUntruncatedError}"
                   (click)="onErrorClick()">
          {{error}}
        </mat-error>
      </div>
    </div>
    <div [@inOut] *ngIf="adressKorrektur.Status !== uiAdressStatus.ADRESSE_KORRIGIERT" [ngClass]="{'lv-adress-vorschlag': true, 'lv-error-state': !!getError()}">
      <lv-label-tooltip
          [label]="uiArtefakt.TextAdresseNichtGefunden"
          [labelSymbol]="nestedSymbol"
          [tooltip]="uiArtefakt.InfoTextTooltipCollapsable"
          [isCollapsable]="uiArtefakt.InfoTextTooltipCollapsableTyp === 'Collapsable'"
          (infotextCollapsableChange)="infotextCollapsableChange($event)">
      </lv-label-tooltip>
      <div class="lv-adress-korrektur-zeile">
        <button [textContent]='"Eigene Eingabe verwenden"' mat-raised-button class="lv-adress-korrektur-button" (click)="onClick(false)"></button>
      </div>
      <div>
        <mat-error class="lv-error-meldung-style" *ngIf="getError() as error"
                   [ngClass]="{'lv-show-untruncated-error': showUntruncatedError}"
                   (click)="onErrorClick()">
          {{error}}
        </mat-error>
      </div>
    </div>

    <lv-info-text-tooltip-collapsable [showInfotext]="showInfotextCollapsable"
                                      [tooltip]="uiArtefakt.InfoTextTooltipCollapsable"
    ></lv-info-text-tooltip-collapsable>
    <lv-infotext-permanent
        [InfoTextPermanent]="uiArtefakt.InfoTextPermanent"></lv-infotext-permanent>
  </div>
</form>
